import React from 'react';

interface Props {
  id: string;
}

export const OwnerPayment = ({ id, }:Props) => {
  return (
    <div>
      płatności { id }
    </div>
  );
};
